import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state: {
    window_h: 0,
    progress: 0,
    range: 0,
    problem1: 0,
    problem2: 0,
    raw: {
      problem1: [],
      all: [],
      problem2: []
    },
    ave: 0,
    ave1: 0,
    ave2: 0
  },
  actions,
  getters,
  mutations
})

export default store
